import { useState, useEffect } from 'react';
import getClient from '@/lib/pusher';
import useLoadUser from './useLoadUser';

let clientPromise = null;
let consumerCount = 0;

const usePusher = () => {
  const [client, setClient] = useState(null);
  const { isLoaded, isLoggedIn } = useLoadUser();
  const shouldConnect = Boolean(isLoaded && isLoggedIn);

  useEffect(() => {
    if (!shouldConnect) {
      return;
    }

    let isActive = true;
    consumerCount += 1;
    clientPromise = clientPromise || getClient();
    const currentClientPromise = clientPromise;

    currentClientPromise
      .then((loadedClient) => {
        if (isActive) {
          setClient(loadedClient);
        }
      })
      .catch(() => {
        if (clientPromise === currentClientPromise) {
          clientPromise = null;
        }
      });

    return () => {
      isActive = false;
      setClient(null);
      consumerCount -= 1;

      if (consumerCount === 0 && clientPromise) {
        const lastClientPromise = clientPromise;
        clientPromise = null;
        lastClientPromise.then((loadedClient) => loadedClient.disconnect()).catch(() => undefined);
      }
    };
  }, [shouldConnect]);

  return client;
};

export default usePusher;
